import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ListItemText from '@material-ui/core/ListItemText'
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'

export function AudienceHelp() {
  const [helpAnchorEl, setHelpAnchorEl] = useState<null | HTMLElement>(null)
  const helpOpen = Boolean(helpAnchorEl)

  return (
    <>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          setHelpAnchorEl(_ => (_ ? null : event.currentTarget))
        }
        component="span"
      >
        <HelpOutlineOutlinedIcon />
      </IconButton>
      <Popper style={{ width: 500 }} open={helpOpen} anchorEl={helpAnchorEl} placement="bottom-end">
        <Paper style={{ padding: '1em' }}>
          <Typography paragraph={true} variant="h5">
            Welcome to Audience Builder!
          </Typography>
          <Typography paragraph={true} variant="body1">
            This is where you will create, view, and manage your Facebook audiences.
          </Typography>
          <Typography variant="body1">
            Facebook audiences are used to target groups of people when running ad campaigns. There
            are many different ways in which you can target people, including but not limited to...
          </Typography>
          <Box display="flex" justifyContent="space-around">
            <List dense={true}>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Age" />
              </ListItem>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Gender" />
              </ListItem>
            </List>
            <List dense={true}>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Geographic Location" />
              </ListItem>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Interests and Behaviors" />
              </ListItem>
            </List>
            <List dense={true}>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Website Visitors" />
              </ListItem>
              <ListItem className="m-0 p-0">
                <ListItemText primary="Facebook Likes" />
              </ListItem>
            </List>
          </Box>
          <Typography paragraph={true} variant="body1">
            Audiences can even be composed together to build up more complex audiences. This works
            on the principle of "including" and "excluding".
          </Typography>
          <Typography paragraph={true} variant="body1">
            For example, you might be interested in creating an audience that includes the group of
            people that have ever interacted with your brand. This is what we call a "primary"
            audience, and we recommend building one as one of the first things you do in Audience
            Builder.
          </Typography>
        </Paper>
      </Popper>
    </>
  )
}
